/// <reference path="../_references.ts"/>
module App.Timeclock {
	import TitleBarService = App.Helpers.TitleBarService;
	import UserSession = App.User.UserSession;

	interface LocalScope extends ng.IScope {
		menu: App.User.UserMenuController;
	}

	export class TimeclockController {
		static $inject = ['$interval', '$state', 'UserSession', 'TimeclockService', '$scope'];

		history: Timeclock[] = [];
		query: string;
		public loading: boolean = true;
		public saving: boolean = false;
		public timeclock: Timeclock = null;
		public clockedTime: string = '';

		init: boolean = false;

		constructor(
			protected $interval: ng.IIntervalService,
			public $state: ng.ui.IStateService,
			protected UserSession: UserSession,
			public TimeclockService: TimeclockService,
			protected $scope: LocalScope
		) {
			if ($scope.menu.showTimeClock) {
				this.doInit();
			} else {
				const watch = $scope.$watch(
					() => $scope.menu.showTimeClock,
					v => {
						if (v) {
							watch();
							this.doInit();
						}
					}
				);
			}
		}

		doInit(): void {
			if (this.init) {
				return;
			}

			this.init = true;

			TimeclockService.addListener((timeclock: Timeclock) => {
				for(var i = this.history.length - 1; i >= 0; --i) {
					if (this.history[i].id === timeclock.id) {
						this.history[i] = timeclock;
						return;
					}
				}
				this.history.unshift(timeclock);
			});

			this.UserSession.getUser().then((user) => {
				const time = new Date(Number(new Date()) - 1000 * 60 * 60 * 24 * 10); // Last 10 days
				this.TimeclockService.fetchAll(
					user.technician.id, {
						'OR[gte@time_in]': time,
						'OR[OR][gte@time_out]': time,
						'OR[OR][time_out]': 'null',
					}
				 ).then((timeclocks: Timeclock[]) => {
					this.history = timeclocks;
					this.updateClockedTime();
					this.$interval(this.updateClockedTime.bind(this), 2000);
					this.loading = false;
				});
			});
		}

		edit(timeclock: Timeclock): void {
			this.timeclock = angular.copy(timeclock);
		}

		clear(): void {
			if (this.saving) return;
			this.timeclock.note = null;
			this.save();
		}

		save(): void {
			if (this.saving) return;
			this.saving = true;
			if (this.timeclock.note === '') this.timeclock.note = null;

			this.TimeclockService.update(this.UserSession.user.technician.id, this.timeclock)
				.then((timeclock: Timeclock) => {
					this.timeclock = null;
				}).finally(() => {
					this.saving = false;
				});
		}

		getFormattedTime(time: Date|null): string {
			if (time === null) return '';

			var then = moment(time);
			return then.format('hh:mm A');
		}

		getFormattedDate(time: Date): string {
			if (time === null) return '';

			var then = moment(time),
				now = moment(new Date());

			return then.week() === now.week()
				? then.format('ddd')
				: then.format('ddd MMM Do');
		}

		getTimeclock(): Timeclock|null {
			return (this.UserSession.user
				&& this.UserSession.user.technician
				&& this.UserSession.user.technician.latest_time
				|| null);
		}

		formatHours(fracHours: number): string {
			var hours = Math.floor(fracHours),
				minutes = Math.round((fracHours - hours) * 60);
			if (hours > 999) return '> 1000 hours';
			return `${hours}h ${minutes}m`;
		}

		updateClockedTime(): void {
			let time = this.getTimeclock();

			this.clockedTime = time && (
				this.formatHours(Math.abs(moment.duration(moment(
					time.active
						? time.time_in
						: time.time_out
				).diff(new Date())).asHours()))
			) || '';
		}

		isActive(): boolean {
			let time = this.getTimeclock();
			return time && time.active;
		}
	}
}
